define(["require", "exports", "tslib", "@material-ui/core/IconButton", "@material-ui/core/styles", "@material-ui/icons/FirstPage", "@material-ui/icons/KeyboardArrowLeft", "@material-ui/icons/KeyboardArrowRight", "@material-ui/icons/LastPage", "react"], function (require, exports, tslib_1, IconButton_1, styles_1, FirstPage_1, KeyboardArrowLeft_1, KeyboardArrowRight_1, LastPage_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    IconButton_1 = tslib_1.__importDefault(IconButton_1);
    FirstPage_1 = tslib_1.__importDefault(FirstPage_1);
    KeyboardArrowLeft_1 = tslib_1.__importDefault(KeyboardArrowLeft_1);
    KeyboardArrowRight_1 = tslib_1.__importDefault(KeyboardArrowRight_1);
    LastPage_1 = tslib_1.__importDefault(LastPage_1);
    React = tslib_1.__importStar(React);
    const useStyles = (0, styles_1.makeStyles)(theme => ({
        root: {
            flexShrink: 0,
            marginLeft: theme.spacing(2.5),
        },
    }));
    const TablePaginationActions = (props) => {
        const classes = useStyles();
        const theme = (0, styles_1.useTheme)();
        const { count, page, rowsPerPage, onPageChange } = props;
        const handleFirstPageButtonClick = event => {
            onPageChange(event, 0);
        };
        const handleBackButtonClick = event => {
            onPageChange(event, page - 1);
        };
        const handleNextButtonClick = event => {
            onPageChange(event, page + 1);
        };
        const handleLastPageButtonClick = event => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };
        return (React.createElement("div", { className: classes.root },
            React.createElement(IconButton_1.default, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" }, theme.direction === 'rtl' ? React.createElement(LastPage_1.default, null) : React.createElement(FirstPage_1.default, null)),
            React.createElement(IconButton_1.default, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" }, theme.direction === 'rtl' ? (React.createElement(KeyboardArrowRight_1.default, null)) : (React.createElement(KeyboardArrowLeft_1.default, null))),
            React.createElement(IconButton_1.default, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "next page" }, theme.direction === 'rtl' ? (React.createElement(KeyboardArrowLeft_1.default, null)) : (React.createElement(KeyboardArrowRight_1.default, null))),
            React.createElement(IconButton_1.default, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page" }, theme.direction === 'rtl' ? React.createElement(FirstPage_1.default, null) : React.createElement(LastPage_1.default, null))));
    };
    exports.default = TablePaginationActions;
});
